interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const baseUrl = 'https://snjrh.cn';

  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '亚洲人成长之路',
      url: baseUrl,
      description: '致力于为亚洲人提供系统性的成长指引，涵盖职业发展、个人成长、文化认同与自我提升。',
      foundingDate: '2024',
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '亚洲人成长之路',
      url: baseUrl,
      description: '探索亚洲人成长的核心议题，涵盖职业发展规划、个人成长方法论、文化认同与自我提升。',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${baseUrl}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      url: baseUrl,
      name: '亚洲人成长之路',
      description: '探索亚洲人成长的核心议题，涵盖职业发展规划、个人成长方法论、文化认同与自我提升。',
      isPartOf: {
        '@type': 'WebSite',
        name: '亚洲人成长之路',
        url: baseUrl,
      },
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  const schema = schemas[type];
  if (!schema) return null;

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}